import React from "react";
import { connect } from "react-redux";

const RecipeServings = ({ recipe }) => {
	return (
		<div>
			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Vegetable</span>
				<span>{recipe.vegetable ? recipe.vegetable : 0} </span>
			</p>
			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Fruit</span>
				<span>{recipe.fruit ? recipe.fruit : 0} </span>
			</p>
			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Dairy</span>
				<span>{recipe.dairy ? recipe.dairy : 0} </span>
			</p>
			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Fat</span>
				<span>{recipe.fat ? recipe.fat : 0} </span>
			</p>

			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Starch</span>
				<span>{recipe.starch ? recipe.starch : 0} </span>
			</p>
			<p className="d-flex flex-row justify-content-between border-bottom">
				<span>Misc</span>
				<span>{recipe.misc ? recipe.misc : 0} </span>
			</p>
			<p className="d-flex flex-row justify-content-between ">
				<span>Protein Calories</span>
				<span>{recipe.protein_calories ? recipe.protein_calories : 0} </span>
			</p>
		</div>
	);
};

const mapDispatchToProps = {};

export default connect(
	null,
	mapDispatchToProps
)(RecipeServings);
